// Cliente da API JSON (contracts/http-api.md). O código de acesso vive num cookie httponly:
// este código nunca o lê nem o guarda.

export class ErroApi extends Error {
  constructor(
    readonly status: number,
    mensagem: string,
  ) {
    super(mensagem);
    this.name = "ErroApi";
  }
}

const MENSAGENS: Record<number, string> = {
  401: "Código de acesso inválido ou ausente.",
  404: "Não encontramos este card.",
  413: "O envio passou do limite: 5.000 caracteres de texto ou 10 MB de arquivo.",
  415: "Esse tipo de arquivo ainda não é aceito. Envie uma imagem (PNG, JPG, WebP, GIF) ou um PDF.",
  423: "Estamos na janela de votação: nenhuma análise nova envolvendo eleição.",
  429: "Limite de envios por hora atingido. Tente mais tarde.",
};

export async function api<T>(caminho: string, init: RequestInit = {}): Promise<T> {
  const cabecalhos = new Headers(init.headers);
  cabecalhos.set("accept", "application/json");
  // Corpo em texto é JSON; FormData (arquivo) leva o próprio content-type com o boundary.
  if (typeof init.body === "string") cabecalhos.set("content-type", "application/json");
  const resposta = await fetch(caminho, {
    ...init,
    headers: cabecalhos,
    credentials: "same-origin",
  });
  if (!resposta.ok) {
    const corpo = (await resposta.json().catch(() => null)) as { erro?: unknown } | null;
    const detalhe = typeof corpo?.erro === "string" ? corpo.erro : undefined;
    throw new ErroApi(resposta.status, MENSAGENS[resposta.status] ?? detalhe ?? "Algo deu errado.");
  }
  if (resposta.status === 204) return undefined as T;
  return (await resposta.json()) as T;
}

/** Valor de texto de um campo de formulário. */
export function campo(dados: FormData, nome: string): string {
  const valor = dados.get(nome);
  return typeof valor === "string" ? valor : "";
}

export const enviarJson = (corpo: unknown): RequestInit => ({
  method: "POST",
  body: JSON.stringify(corpo),
});
